var _rect, _rect2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDuplicateIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1015,
    transform: "translate(-1211 -657)",
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_44839)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -931,
    y: -293,
    width: 976,
    height: 651,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 976,
    height: 60,
    transform: "translate(-931 -20.3594)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#4BDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4987 8.79297H10C9.80109 8.79297 9.61032 8.88516 9.46967 9.04925C9.32902 9.21334 9.25 9.4359 9.25 9.66797V17.2498C9.25 17.4819 9.32902 17.7045 9.46967 17.8686C9.61032 18.0327 9.80109 18.1248 10 18.1248H16.4987C16.6977 18.1248 16.8884 18.0327 17.0291 17.8686C17.1697 17.7045 17.2487 17.4819 17.2487 17.2498V9.66797C17.2487 9.4359 17.1697 9.21334 17.0291 9.04925C16.8884 8.88516 16.6977 8.79297 16.4987 8.79297Z",
    fill: "#4BDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7487 7.91813V7.04313C14.7488 6.73408 14.6438 6.43762 14.4568 6.21868C14.2699 5.99974 14.0161 5.87616 13.7513 5.875H7.75125C7.48601 5.87615 7.23191 5.99959 7.04435 6.21841C6.85679 6.43723 6.75099 6.73367 6.75 7.04313V14.0431C6.75099 14.3522 6.85692 14.6482 7.04458 14.8663C7.23225 15.0844 7.48635 15.2069 7.75125 15.2069H8.50125V9.66813C8.50125 9.204 8.65929 8.75888 8.94059 8.43069C9.22189 8.1025 9.60343 7.91813 10.0013 7.91813H14.7487Z",
    fill: "#4BDADA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_184_44839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-232 -70C-234.209 -70 -236 -68.2091 -236 -66V-12.8261C-236 -10.617 -234.178 -8.82609 -231.969 -8.82609H-106.868L-99 -0.405762L-91.1325 -8.82609H20.9689C23.178 -8.82609 25 -10.6169 25 -12.8261V-66C25 -68.2091 23.2091 -70 21 -70H-232Z",
    fill: "#05060A",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_184_44839",
    x: -240,
    y: -70,
    width: 269,
    height: 77.5942,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.909804 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_44839"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_44839",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_44839"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -931,
    y: -293,
    width: 976,
    height: 651,
    rx: 8,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDuplicateIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/duplicate-icon.75cc47a8.svg";
export { ForwardRef as ReactComponent };